(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ts-lifestyle-carousel')) {
    customElements.define('ts-lifestyle-carousel', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.timer);
        if (this.events) this.events.abort();
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.initialized = false;
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.track = this.querySelector('.ts-lifestyle-carousel__track');
        this.controls = this.querySelector('.ts-lifestyle-carousel__controls');
        this.toggle = this.querySelector('[data-carousel-toggle]');
        if (!this.track || !this.controls || !this.toggle) return;
        this.initialized = true;
        this.cards = Array.from(this.track.children);
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 699px)');
        this.userPaused = false;
        this.hovered = false;
        this.touching = false;
        this.inView = false;

        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.schedule();
        }, options);
        this.querySelector('[data-carousel-prev]').addEventListener('click', () => this.manualMove(-1), options);
        this.querySelector('[data-carousel-next]').addEventListener('click', () => this.manualMove(1), options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
        }, options);
        this.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); }
        }, options);
        this.track.addEventListener('pointerdown', () => {
          this.touching = true;
          this.schedule();
        }, options);
        const endTouch = () => { this.touching = false; this.schedule(); };
        window.addEventListener('pointerup', endTouch, options);
        window.addEventListener('pointercancel', endTouch, options);
        this.track.addEventListener('wheel', () => this.schedule(), { ...options, passive: true });
        this.addEventListener('focusin', () => this.schedule(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => {
          if (this.isConnected) this.schedule();
        }), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.reducedMotion.addEventListener('change', () => this.schedule(), options);
        this.mobile.addEventListener('change', () => this.schedule(), options);

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
            this.schedule();
          }, { threshold: 0.25 });
          this.visibilityObserver.observe(this);
        } else {
          this.inView = true;
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.schedule());
          this.resizeObserver.observe(this.track);
        }
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected) return;
        const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
        this.controls.hidden = !scrollable;
        const paused = this.userPaused || this.reducedMotion.matches;
        this.toggle.textContent = paused ? 'Play' : 'Pause';
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggle.setAttribute('aria-label', paused ? 'Play automatic image movement' : 'Pause automatic image movement');
        this.toggle.disabled = this.reducedMotion.matches;
        this.toggle.title = this.reducedMotion.matches ? 'Automatic movement is disabled by your reduced motion preference' : '';
        if (!scrollable || paused || !this.mobile.matches || !this.inView || this.hovered || this.touching || document.hidden || this.contains(document.activeElement)) return;
        this.timer = setTimeout(() => {
          this.move(1);
          this.schedule();
        }, 5000);
      }

      manualMove(direction) {
        this.userPaused = true;
        this.move(direction);
        this.schedule();
      }

      move(direction) {
        if (!this.cards.length) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const view = this.track.getBoundingClientRect();
        const inset = 12;
        const start = rtl ? view.right - inset : view.left + inset;
        let closest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const box = card.getBoundingClientRect();
          const current = Math.abs((rtl ? box.right : box.left) - start);
          if (current < distance) { distance = current; closest = index; }
        });
        const position = Math.abs(this.track.scrollLeft);
        const end = this.track.scrollWidth - this.track.clientWidth;
        let target = closest + direction;
        if (direction > 0 && position >= end - 2) target = 0;
        if (direction < 0 && position <= 2) target = this.cards.length - 1;
        target = Math.max(0, Math.min(this.cards.length - 1, target));
        const box = this.cards[target].getBoundingClientRect();
        const delta = (rtl ? box.right : box.left) - start;
        this.track.scrollBy({ left: delta, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
